import { useGetTicketPdf, useGetVoucherPdf } from "@app/store/service/connectorService"
import { IframeMessages } from "@app/utils/constants"
import { getDateString, getPriceString } from "@app/utils/localeUtils"
import { faCircleArrowDown } from "@fortawesome/free-solid-svg-icons/faCircleArrowDown"
import { faCircleArrowUp } from "@fortawesome/free-solid-svg-icons/faCircleArrowUp"
import { faDownload } from "@fortawesome/free-solid-svg-icons/faDownload"
import { faSpinner } from "@fortawesome/free-solid-svg-icons/faSpinner"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { AnimatePresence, m } from "framer-motion"
import { useCallback, useEffect, useState } from "react"
import { MyParadiseOrderDetail } from "./MyParadiseOrderDetail"

import "./MyParadiseOrderSummary.css"

export const MyParadiseOrderSummary = ({ webToken, orderNumber, date, totalAmount, visitDates }) => {
	const [isCollapseOpen, setIsCollapseOpen] = useState(false)
	const [cleanedVisitDate, setCleanedVisitDates] = useState([])
	const [requestDownload, setRequestDownload] = useState(false)
	const ticketRequest = useGetTicketPdf({ webToken }, { skip: !requestDownload })
	const voucherRequest = useGetVoucherPdf({ webToken }, { skip: !requestDownload })

	useEffect(() => {
		const cleanded = visitDates ? Array.from(new Set(visitDates)) : []

		setCleanedVisitDates(cleanded)
	}, [visitDates])

	const openInvoice = useCallback(() => {
		if (!requestDownload) return

		if (ticketRequest.data?.url) {
			if (window.self !== window.top) {
				window.parent.postMessage(IframeMessages.openUrl + ";" + ticketRequest.data.url, "*")
			} else {
				window.open(ticketRequest.data.url, "_blank")
			}
		}

		if (voucherRequest.data?.url) {
			if (window.self !== window.top) {
				window.parent.postMessage(IframeMessages.openUrl + ";" + voucherRequest.data.url, "*")
			} else {
				window.open(voucherRequest.data.url, "_blank")
			}
		}
	}, [requestDownload, ticketRequest, voucherRequest])

	useEffect(() => {
		let ticketLoaded = ticketRequest.isUninitialized === false && ticketRequest.isFetching === false
		let voucherLoaded = voucherRequest.isUninitialized === false && voucherRequest.isFetching === false
		if (ticketLoaded && voucherLoaded) {
			openInvoice()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ticketRequest, voucherRequest])

	return (
		<div className="">
			<div className="w-100 border-top color-border-secondary pt-3 flex mb-3">
				<div className="myParadiseOrderSummary__details">
					<div className="f3 flex-1 myParadiseOrderSummary__date">{getDateString(new Date(date))}</div>
					<div className="f3 flex-1 myParadiseOrderSummary__orderNumber">{orderNumber}</div>
					<div className=" f3 flex-1 myParadiseOrderSummary__visitDates">
						{cleanedVisitDate
							.map(date => {
								return getDateString(new Date(date))
							})
							.join(", ")}
					</div>
					<div className="f3 flex-1 myParadiseOrderSummary__price">{getPriceString(totalAmount)}</div>
				</div>
				<div className="myParadiseOrderSummary__download">
					{(!ticketRequest.error || !voucherRequest.error) && (
						<FontAwesomeIcon
							className="myParadiseOrderSummary__downArrow mr-3 clickable"
							size="xl"
							style={{ color: "var(--color-secondary-700)" }}
							icon={ticketRequest.isFetching || voucherRequest.isFetching ? faSpinner : faDownload}
							spin={ticketRequest.isFetching || voucherRequest.isFetching}
							onClick={() => {
								if (requestDownload === false) {
									setRequestDownload(true)
									return
								}
								if (ticketRequest.isFetching || voucherRequest.isFetching) {
									return
								}

								openInvoice()
							}}
						/>
					)}

					<FontAwesomeIcon
						className="myParadiseOrderSummary__downArrow"
						size="xl"
						style={{ color: "var(--color-secondary-700)" }}
						icon={isCollapseOpen ? faCircleArrowUp : faCircleArrowDown}
						onClick={() => setIsCollapseOpen(isCollapseOpen ? false : true)}
					/>
				</div>
			</div>

			<AnimatePresence>
				{isCollapseOpen && (
					<m.div
						className="z-9 of-hidden w-100"
						style={{ originY: 0 }}
						initial={{
							key: "modal",
							height: 0,
						}}
						animate={{
							height: "auto",
							transition: {
								duration: 0.3,
							},
						}}
						exit={{
							height: 0,
							transition: { duration: 0.3 },
						}}
					>
						<MyParadiseOrderDetail webToken={webToken} />
					</m.div>
				)}
			</AnimatePresence>
		</div>
	)
}
